module.exports = __webpack_public_path__ + "img/cashFlow-md.a9e8b012.svg";